// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingNew_loadingContainer__l9LLM","animationContainer":"LoadingNew_animationContainer__U3lpb","animation":"LoadingNew_animation__ibQQm"};